import { z } from 'zod'

export const updateSupplyPoliticsSchema = z.object({
  consumption_password_update_restriction: z.string().min(1, 'Selecione uma opção'),
})

export type UpdateSupplyPoliticsSchema = z.infer<typeof updateSupplyPoliticsSchema>
